import type { SVGProps } from 'react'
const SvgSyQuoteUp = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M8.09 11.63H3.4c.08-4.67 1-5.44 3.87-7.14.33-.2.44-.62.24-.96a.7.7 0 0 0-.96-.24c-3.38 2-4.56 3.22-4.56 9.04v5.39c0 1.71 1.39 3.09 3.09 3.09h3c1.76 0 3.09-1.33 3.09-3.09v-3c.01-1.76-1.32-3.09-3.08-3.09" />
		<path
			d="M18.91 11.63h-4.69c.08-4.67 1-5.44 3.87-7.14.33-.2.44-.62.24-.96a.7.7 0 0 0-.96-.24c-3.38 2-4.56 3.22-4.56 9.04v5.39c0 1.71 1.39 3.09 3.09 3.09h3c1.76 0 3.09-1.33 3.09-3.09v-3c.01-1.76-1.32-3.09-3.08-3.09"
			opacity={0.4}
		/>
	</svg>
)
export default SvgSyQuoteUp
